
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"68","height":"64","viewBox":"0 0 68 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#hobbies_svg__clip0_7935_26386)","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M33.598 52.462V42.23M49.943 40.596l-8.172-4.298M38.647 26.685l5.049-5.303M25.426 36.298l-8.173 4.298M33.598 16.454l5.049 10.23 11.296 1.647-8.172 7.967 1.925 11.248-10.098-5.315-10.097 5.315 1.925-11.248-8.173-7.967 11.296-1.646 5.05-10.23zM23.5 21.382l5.05 5.303","stroke":"#1D1D1B"}}),_c('path',{attrs:{"d":"M21.624 50.428L13.39 63.092M45.572 50.428l8.234 12.664M66.288 24.663l-13.318 2.99M33.598.908v12.664M.908 24.663l13.318 2.99M33.598.908l10.098 20.474 22.592 3.28-16.345 15.934 3.862 22.496-20.207-10.63-20.207 10.63 3.862-22.496L.908 24.663 23.5 21.382 33.599.908z","stroke":"#B69E64"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"hobbies_svg__clip0_7935_26386"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h67.196v64H0z"}})])])])
          )
        }
      }
    